import React from "react";
import { classes } from "lib/actions/util";

export default function LoadingSkeleton(p: { className?: string }) {
  return (
    <div
      className={classes(
        p.className,
        "animate-pulse rounded bg-gradient-to-r from-white to-neutral-200",
      )}
    />
  );
}
